import { enableLegacyApplications } from '@flowwai-frontend/bps-officer-web/common/ui'
import {
   getLegacyApplicationsDynamicConfig,
   useDynamicFeatureToggles
} from '@flowwai-frontend/shared-web/feature-toggles'

import { useUserAppConfigStore } from './stores/useUserAppConfigStore'

export const useGetLegacyApplicationsFeatureToggle = (): {
   isLegacyApplicationsEnabled: boolean
} => {
   const { getDynamicConfig } = useDynamicFeatureToggles()
   const userStore = useUserAppConfigStore()

   const { isEnabled, userIds } = getLegacyApplicationsDynamicConfig(
      getDynamicConfig
   )

   const userId = userStore.userId

   // An empty user_ids list means the feature is on for every user.
   const isUserAllowed =
      userIds.length === 0 || (!!userId && userIds.includes(userId))

   return {
      isLegacyApplicationsEnabled:
         enableLegacyApplications && isEnabled && isUserAllowed
   }
}
